import React, { FunctionComponent } from "react";
import { Content } from "@iventis/translations/content/typed-content";
import { ExportUrl } from "@iventis/domain-model/model/exportUrl";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import EnumToRadioButtons from "@iventis/components/src/enum-to-radio-buttons";
import { ScheduleExport } from "./schedule.types";

export const ExportScheduleOptions: FunctionComponent<{
    onSelect: (option: ScheduleExport) => void;
    selected: ScheduleExport;
    projectAdmin: boolean;
    exportUrls: ExportUrl[];
}> = ({ onSelect, selected, projectAdmin, exportUrls }) => {
    const translate = useIventisTranslate();
    return (
        <>
            <p>{translate(Content.schedule2.exports.message)}</p>
            <EnumToRadioButtons<ScheduleExport>
                radioButtons={[
                    {
                        name: translate(Content.schedule2.exports.downloadTitle),
                        description: translate(Content.schedule2.exports.downloadDescription),
                        type: ScheduleExport.DOWNLOAD,
                    },
                    {
                        name: `${exportUrls[0]?.name || translate(Content.schedule2.exports.notAvailable)}`,
                        description: translate(Content.schedule2.exports.publishedDescription, { exportDestinationName: exportUrls[0]?.name }),
                        type: ScheduleExport.URL,
                        disabled: !projectAdmin || exportUrls.length === 0,
                    },
                ]}
                value={selected}
                onChange={onSelect}
            />
        </>
    );
};

export enum ScheduleShareOption {
    LINK,
    EXPORT,
}
